import { useState } from "react";

import { lerPreferencia, gravarPreferencia } from "../../services/preferencias";

// Mantém o nome que os componentes já importam, mas guarda em cookie: o
// localStorage saiu do projeto junto com o token, e deixar sobras nele só
// convidaria a voltar a usá-lo para algo sensível.
export function useLocalStorage(key, initialValue) {
	const [storedValue, setStoredValue] = useState(() =>
		lerPreferencia(key, initialValue)
	);

	const setValue = value => {
		const valueToStore =
			value instanceof Function ? value(storedValue) : value;

		setStoredValue(valueToStore);
		gravarPreferencia(key, valueToStore);
	};

	return [storedValue, setValue];
}
